import React from 'react'
import Topbar from '../../Home/Mainhomeone/Topbar'
import Header from '../..//Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Footer1 from '../../Globle/Footer1'
import Breadecrumb from '../../Globle/Breadecrumb'
import ShopDetails from '../Mainshopdetails/ShopDetails'
import Comment from '../Mainshopdetails/Comment'

const Main = () => {
    return (
        <>
            <Topbar />
            <Header />
            <Navigation />
            <Breadecrumb title='Product Detail' />
            <ShopDetails />
            <Comment />
            <Footer1 />
        </>
    )
}

export default Main
